import { useMemo } from "react";
import { STORAGE_PREVIEW_BASE } from "@/utils/constant";
import { useAuthorizedMediaUrl } from "@/utils/authorized-media";

interface UseAuthorizedAudioOptions {
  src?: string;
  payload?: string;
}

interface UseAuthorizedAudioResult {
  audioSrc: string;
  isResolving: boolean;
  error: string | null;
}

export function useAuthorizedAudio({ src, payload }: UseAuthorizedAudioOptions): UseAuthorizedAudioResult {
  const requestUrl = useMemo(() => {
    const safeSrc = src ?? "";
    const base = (STORAGE_PREVIEW_BASE ?? "").replace(/\/$/, "");
    return payload ? `${base}/api/media/file?token=${payload}` : safeSrc;
  }, [payload, src]);

  // <audio> cannot carry headers. The media service worker signs the request
  // instead so playback streams; without it we fall back to downloading the
  // whole file and playing it from an object URL.
  const { src: audioSrc, isLoading, error } = useAuthorizedMediaUrl(requestUrl, { stream: true });

  return { audioSrc, isResolving: isLoading, error };
}
